<!--
 * @Description: 账户销户展示界面
 * @Author: situgen@szkingdom.com
 * @Date: 2025-06-20 14:44:10
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div :class="'bizcomp-acct-info bizcomp ' + className">
        <!-- 头部信息 -->
        <div class="acc-info-head-contain">
            <div class="acc-info-img-name">
                <div class="act-img">
                    <img v-if="info.headimage" :src="$util.fileDownloadPath(info.headimage)" />
                    <img v-else :src="require('../../assets/img/account-img.png')" />
                </div>

                <div class="acc-info-name-div">
                    <div class="acc-info-name">
                        {{ info.custname }}
                    </div>
                    <div class="acc-info-copywriting">账户销户申请</div>
                </div>
            </div>
        </div>
        <!-- 基本信息 -->
        <div class="basic-info-contain">
            <div class="basic-info-head head-contain">
                <div class="basic-info">
                    <div class="basic-info-bar"></div>
                    <div class="basic-info-title">
                        <span>符合以下条件的客户可以办理</span>
                        <span style="color: var(--color-primary)">
                            （温馨提示：确认销户后不可撤销，操作完成后将退出系统不可登录，请确认）
                        </span>
                    </div>
                </div>
            </div>

            <div class="condition-container">
                <div class="number-list">
                    <div class="list-item">账户中已无任何基金份额；</div>
                    <div class="list-item">当日账户已无任何业务申请；</div>
                    <div class="list-item">账户无未确认交易申请；</div>
                    <div class="list-item">账户状态正常，未被冻结或挂失等；</div>
                    <div class="list-item">无生效中（含暂停状态）的定投协议；</div>
                </div>

                <div v-if="!tradePasswordShow">
                    <el-button type="primary" v-on:click="openConfirm">
                        我已确认，继续注销
                    </el-button>
                </div>
                <div v-if="tradePasswordShow">
                    <span>交易密码：</span>
                    <el-input
                        v-model="tradePassword"
                        type="password"
                        placeholder="请输入交易密码"
                        class="input-box"
                    ></el-input>

                    <el-button
                        :disabled="!tradePassword"
                        type="primary"
                        class="confirm-btn"
                        v-on:click="confirmCloseAccount"
                    >
                        我符合以上条件，我确认要销户
                    </el-button>
                </div>
            </div>
        </div>
        <smsValid
            v-show="bindPhoneVisible"
            sms-title="短信验证码"
            :mobileno="info.mobileno"
            :en-mobileno="info.en_mobileno"
            :dialog-visible="bindPhoneVisible"
            sms-type="3"
            :biz-type="$const.IMG_BIZTYPE.UNSUBSCRIBE"
            :close-with-reset="false"
            :show-remote="false"
            :skip-verification="skipVerification"
            v-on:sms-comfirm="bindPhoneConfirm"
            v-on:close="bindPhoneClose"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import smsValid from "@/components/form/smsValid";

export default {
    name: "Unsubscribe",
    components: {
        smsValid
    },
    mixins: [mixin],
    data() {
        return {
            headimage: "",
            info: {},
            otherInfo: {},
            tradePassword: "",
            skipVerification: "0",
            tradePasswordShow: false,
            bindPhoneVisible: false,
            userState: ""
        };
    },
    computed: {},
    mounted() {
        this.getUserInfo();
        if (window.performance) {
            const navEntry = performance.getEntriesByType("navigation")[0];
            if (navEntry) {
                // type 1: 页面刷新   type 2: 通过前进/后退进入
                if (navEntry.type === "reload") {
                    if (sessionStorage.getItem("accountClosureSuccessfulFlag")) {
                        this.logoff();
                    }
                    // 这里执行刷新后的操作
                }
            }
            // 兼容旧版浏览器
            else if (performance.navigation.type === 1) {
                if (sessionStorage.getItem("accountClosureSuccessfulFlag")) {
                    this.logoff();
                }
            }
        }
    },
    methods: {
        openConfirm() {
            this.$confirm("确定销户后不可撤回，请再次确认", "提示", {
                confirmButtonText: "确认注销",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.bindPhoneVisible = true;
            });
        },
        bindPhoneClose() {
            this.bindPhoneVisible = false;
        },
        async bindPhoneConfirm(smscode) {
            if (this.userState == "未开户") {
                const res = await userApi.closeAccountMid({
                    checktype: "1", // 校验类型:1-短信 2-人脸核身 3-交易密码
                    en_mobileno: this.info.en_mobileno,
                    smscode
                });
                if (res.code == "0") {
                    sessionStorage.setItem("accountClosureSuccessfulFlag", "1");
                    let day = this.$cache.getCompanyInfoParam("100165") || 30;
                    this.$alert(
                        `您的账户已成功注销，若需重新开户，请在${day}天后再次注册/登录`,
                        "",
                        {
                            showClose: false,
                            confirmButtonText: "退出系统",
                            type: "info",
                            callback: () => {
                                this.logoff();
                            }
                        }
                    );
                }
            } else {
                this.tradePasswordShow = true;
            }
        },
        async confirmCloseAccount() {
            if (!this.tradePassword) {
                this.$message.error("请输入交易密码");
                return false;
            }

            const res = await userApi.closeAccountMid({
                checktype: "3", // 校验类型:1-短信 2-人脸核身 3-交易密码
                tradepassword: this.$util.enc(this.tradePassword)
            });
            if (res.code == "0") {
                sessionStorage.setItem("accountClosureSuccessfulFlag", "1");
                this.$alert(
                    "销户业务需要T+2个交易日确认，如需重新开户，请于销户2个交易日后进行申请",
                    "",
                    {
                        showClose: false,
                        confirmButtonText: "退出系统",
                        type: "info",
                        callback: () => {
                            this.logoff();
                        }
                    }
                );
            }
        },

        async logoff() {
            const res = await userApi.logout();
            if (res.error) return;
            this.$store.dispatch("logout", res.data).then(() => {
                sessionStorage.setItem("accountClosureSuccessfulFlag", "");
                this.$router.replace("/");
            });
        },

        async getUserInfo() {
            const _this = this;
            this.info = await this.$cache.getUser();
            this.info.headimage = this.$cache.getHeadImage();
            _this.info = Object.assign(
                {},
                _this.info,
                _this.$cache.getIsEncrypted()
                    ? {
                          custname: this.$cache.getUser().custname
                      }
                    : {}
            );
            if (!_this.info.custno) {
                this.skipVerification = "1";
                this.userState = "未开户";
            } else {
                this.skipVerification = "0";
                // 已绑卡根据isBind字段才弹出是否需要输入交易密码
                if (this.$cache.getBinded()) {
                    this.userState = "已绑卡";
                } else {
                    this.userState = "未绑卡";
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
/* 用户信息 */
.bizcomp-acct-info {
    .acc-info-head-contain {
        display: flex;
        padding: 25px 16px;
        height: 120px;
        border-radius: 6px;
        background: linear-gradient(180deg, var(--color-accent) 0%, var(--color-accent) 100%);
        box-sizing: border-box;
        .acc-info-img-name {
            display: flex;
            width: 369px;
            .act-img {
                position: relative;
                margin-left: 16px;
                width: 65px;
                height: 65px;
                float: left;
                border-radius: 100% 100%;
                -webkit-border-radius: 100% 100%;
                overflow: hidden;
                img {
                    width: 65px;
                    height: 65px;
                    border-radius: 50%;
                    border: 1px solid var(--color-divided);
                    box-sizing: border-box;
                }
            }
            .acc-info-name-div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 10px;
                .acc-info-name {
                    font-size: 20px;
                    font-weight: bold;
                    color: var(--color-text-primary);
                }
                .acc-info-copywriting {
                    margin-top: 12px;
                    font-size: 14px;
                    font-weight: normal;
                    color: var(--color-text-regular);
                }
            }
        }
    }
    .basic-info-contain {
        margin-top: 20px;
        border: 1px solid var(--color-divided);
        box-sizing: border-box;
        .head-contain {
            display: flex;
            justify-content: space-between;
            padding-right: 16px;
            .basic-info {
                background: #f9f9f9;
                display: flex;
                align-items: center;
            }
        }
        .basic-info-head {
            height: 60px;
            background: #f9f9f9;
            display: flex;
            align-items: center;
            padding-left: 16px;

            .basic-info-bar {
                width: 4.68px;
                height: 16px;
                background: var(--color-primary);
            }
            .basic-info-title {
                margin-left: 6px;
                font-size: 18px;
                font-weight: bold;
                color: var(--color-text-primary);
            }
        }
    }
    .condition-container {
        border: 1px solid var(--color-divided);
        border-radius: 4px;
        padding: 20px;
        margin: 20px 0;

        .notice-text {
            color: var(--color-text-regular);
            font-size: 14px;
            line-height: 1.5;
            margin-bottom: 15px;
        }

        .number-list {
            counter-reset: section;
            margin-left: 0;
            padding-left: 0;
        }

        .list-item {
            position: relative;
            padding-left: 24px;
            margin-bottom: 12px;
            color: var(--color-text-regular);
            font-size: 14px;
            &::before {
                content: counter(section) "";
                counter-increment: section;
                position: absolute;
                left: 0;
                color: var(--color-primary);
                font-weight: 500;
                border: 1px solid var(--color-primary);
                border-radius: 50%;
                padding: 2px 4px;
                font-weight: bold;
            }
        }

        .input-box {
            width: 300px;
            margin-bottom: 10px;
        }

        .confirm-btn {
            width: 300px;
            margin-left: 20px;
        }
    }
}
</style>
